import React, { useMemo } from "react"

import { ColoredBadge, useTheme } from "@l2r-front/l2r-ui"

import { getDisplayedFigures } from "../../utils/getDisplayedFigures"
import { getLegendItemForGrade } from "../../utils/getLegendItemForGrade"

export function GradeBadge(props: GradeBadgeProps): React.ReactNode {

    const {
        className,
        id,
        figuresCount = 2,
        grade,
        legend,
    } = props

    const theme = useTheme()

    const legendItemForGrade = useMemo(() => {
        if (legend && typeof grade === "number" && theme) {
            return getLegendItemForGrade(legend, grade, theme)
        }
    }, [grade, legend, theme])

    if (!grade && grade !== 0) {
        return <ColoredBadge
            className={className}
            id={id}
            backgroundColor="elevation/disabled"
            text="-"
            textColor={theme.palette["common/black_states"].main}
        />
    }

    const displayedGrade = getDisplayedFigures(grade, figuresCount)

    if (!legendItemForGrade) {
        return null
    }

    return <ColoredBadge
        id={id}
        backgroundColor={theme.palette[legendItemForGrade.color].main}
        className={className}
        text={displayedGrade.toString()}
        textColor={legendItemForGrade.textColor}
    />
}

type GradeBadgeProps = {
    className?: string
    id?: string
    figuresCount?: number
    grade?: number
    legend?: Array<{
        color: string
        label: string
        minValue: number
        maxValue: number
    }>
}
